<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.ol-custom {
  list-style: none;
  counter-reset: item;
}
.li-custom {
  counter-increment: item;
  margin-bottom: 10px;
}
.li-custom:before {
  margin-right: 10px;
  content: counter(item);
  background: #3e5d92;
  border-radius: 50px;
  color: white;
  width: 1.5em;
  text-align: center;
  display: inline-block;
}
</style>
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
          <li class="nav-item col-6 px-0">
            <router-link
              :to="'/sertifikasi/jadwal-tc/sesi-1/'+this.$route.params.id_jadwal_tc"
              class="nav-link p-3 px-5 font-weight-bold text-white border-0"
              style="background-color: #486ba7; display: flex; justify-content: center; align-items: center;"
              id="home-tab"
              data-toggle="tab"
              href="#home"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            >Sertifikasi</router-link>
          </li>
          <li class="nav-item col-6 px-0">
            <router-link
              :to="'/sertifikasi/jadwal-tc/rpl-sesi-satu/'+this.$route.params.id_jadwal_tc"
              class="nav-link p-3 px-5 font-weight-bold text-white"
              style="display: flex; justify-content: center; align-items: center;"
              id="profile-tab"
              data-toggle="tab"
              href="#profile"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
            >RPL</router-link>
          </li>
        </ul>
      </div>
    </div>
    <CCard>
      <!-- Tabs -->
      <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
        <li class="nav-item">
          <router-link
            :to="'/sertifikasi/jadwal-tc/sesi-1/'+this.$route.params.id_jadwal_tc"
            class="nav-link p-3 px-5 font-weight-bold text-white"
            id="home-tab"
            data-toggle="tab"
            href="#home"
            role="tab"
            aria-controls="home"
            aria-selected="true"
          >Sesi 1</router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="'/sertifikasi/jadwal-tc/sesi-2/'+this.$route.params.id_jadwal_tc"
            class="nav-link p-3 px-5 font-weight-bold text-white border-0"
            style="background-color: #486ba7;"
            id="profile-tab"
            data-toggle="tab"
            href="#profile"
            role="tab"
            aria-controls="profile"
            aria-selected="false"
          >Sesi 2</router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="'/sertifikasi/jadwal-tc/sesi-3/'+this.$route.params.id_jadwal_tc"
            class="nav-link p-3 px-5 font-weight-bold text-white"
            id="contact-tab"
            data-toggle="tab"
            href="#contact"
            role="tab"
            aria-controls="contact"
            aria-selected="false"
          >Sesi 3</router-link>
        </li>
      </ul>
      <!-- Data sesi 1-->
      <CCardBody>
        <CRow>
          <div class="col-sm-12 col-xl-2">
            <div class="form-group">
              <label for>Data Perhalaman</label>
              <select class="form-control" name id>
                <option>10</option>
                <option>25</option>
                <option>100</option>
                <option>Semua Data</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12 col-xl-2">
            <div class="form-group">
              <label for>Pencarian</label>
              <input type="text" name id class="form-control" placeholder="Cari Data ..." />
            </div>
          </div>
          <div class="col-sm-12 col-xl-2">
            <div class="form-group">
              <label for>Sertifikasi</label>
              <select class="form-control" name id>
                <option>Semua Data</option>
              </select>
            </div>
          </div>
          <div class="col-lg-6 col-sm-12 d-flex align-items-center">
            <!-- <CButton color="info" style="float:right;margin-right:10px" class="btn-md ml-auto">Print</CButton> -->
            <CButton color="danger" style="float:right;margin-right:10px" class="btn-md ml-auto">Export PDF</CButton>
            <CDropdown
              toggler-text="Ekspor Excel"
              color="warning"
              class="mr-2 d-inline-block text-white float-right"
            >
              <CDropdownItem>Export All</CDropdownItem>
              <CDropdownItem>Export Page</CDropdownItem>
            </CDropdown>
            <router-link to="/sertifikasi/jadwal-tc/upload-absensi-sertifikasi">
              <CButton
                color="warning"
                style="float:right;margin-right:10px"
                class="btn-md text-white"
              >UPLOAD ABSENSI</CButton>
            </router-link>
          </div>
        </CRow>
        <CRow>
          <CCol lg="12" class="table-responsive">
            <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
              <template #no="{ index}">
                <td class="py-2">{{ index+1 }}</td>
              </template>
              <template #no_anggota="{item}">
                <td class="py-2 text-center">{{item.no_anggota ? item.no_anggota : '-'}}</td>
              </template>
              <template #nama_lengkap="{item}">
                <td class="py-2 text-center">{{item.nama_lengkap ? item.nama_lengkap : "-"}}</td>
              </template>
              <template #nama_level="{item}">
                <td class="py-2 text-center">{{item.nama_level ? item.nama_level : "-"}}</td>
              </template>
              <template #no_handphone="{item}">
                <td class="py-2 text-center">{{item.no_handphone ? item.no_handphone : "-"}}</td>
              </template>
              <template #kehadiran="{item}">
                <td class="py-2">
                  <button class="btn btn-sm btn-success" v-if="item.kehadiran == 1">YA</button>
                  <button class="btn btn-sm btn-danger" v-else>TIDAK</button>
                </td>
              </template>
              <template #sertifikasi="{item}">
                <td class="py-2 text-center">{{item.sertifikasi ? item.sertifikasi : "-"}}</td>
              </template>
              <template #mata_uji="{item}">
                <td class="py-2 text-center">
                  <div v-for="value in item.mata_uji" :key="value">{{value ? value : "-"}}</div>
                </td>
              </template>
              <template #tombol_dokumen_terverifikasi="{item}">
                <td class="py-2">
                  <button
                    class="btn btn-sm btn-success"
                    v-if="item.tombol_dokumen_terverifikasi == 1"
                  >Terverifikasi</button>
                  <button class="btn btn-sm btn-danger" v-else>Belum Terverifikasi</button>
                </td>
              </template>
              <template #aksi="{item}">
                <td class="py-2 d-flex align-items-center">
                  <CButton
                    color="warning"
                    class="btn-sm text-white"
                    square
                    @click="sendEmail(item)"
                  >
                    <font-awesome-icon icon="envelope" />
                  </CButton>&nbsp;&nbsp;
                  <CButton color="success" class="btn-sm mx-1" square @click="modalVerif = true">
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </CButton>&nbsp;&nbsp;
                  <CButton color="info" class="btn-sm" square @click="updateData(item)">
                    <font-awesome-icon icon="edit" />
                  </CButton>&nbsp;&nbsp;
                </td>
              </template>
            </CDataTable>
            <CPagination
              style="float:right"
              :active-page.sync="currentPage"
              :pages="10"
              responsive
            />
          </CCol>
        </CRow>
        <!-- Modal Edit -->
        <CModal
          title="Modal title"
          :show.sync="myModal"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm @submit.prevent="postData">
            <CRow>
              <div class="modal-body">
                <form>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="name font-weight-bold" class="font-weight-bold">Nama</label>
                      <input
                        type="text"
                        v-model="formdataKehadiran.nama_lengkap"
                        class="form-control"
                        id="name"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="sesi1" class="font-weight-bold">Kehadiran</label>
                      <select class="form-control" name id v-model="formdataKehadiran.kehadiran">
                        <option>Pilih Kehadiran</option>
                        <option value="1">YA</option>
                        <option value="0">TIDAK</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="sertifikasi" class="font-weight-bold">Sertifikasi</label>
                      <input
                        type="text"
                        v-model="formdataKehadiran.nama_sertifikasi"
                        class="form-control"
                        id="sertifikasi"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for class="font-weight-bold">Mata Uji</label>
                      <br />
                      <ol class="ol-custom pl-3">
                        <li
                          class="li-custom"
                          v-for="value in formdataKehadiran.mata_uji"
                          :key="value"
                        >{{value ? value : "-"}}</li>
                      </ol>
                    </div>
                  </div>
                </form>
              </div>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h4 font-weight-bold">Edit</h6>            
          </template>
          <template #footer>
            <CButton @click="myModal = false" color="danger">Tutup</CButton>
            <CButton type="submit" @click="postData()" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->

        <!-- End Modal Status Mata Uji -->

        <!-- Modal Email -->
        <CModal
          title="Modal title"
          :show.sync="modalEmail"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm v-on:submit.prevent="postDataEmail">
            <CRow>
              <CCol sm="12">
                <CInput
                  class="font-weight-bold"
                  label="Subjek"
                  placeholder="Masukkan Subjek"
                  v-model="formEmail.subject"
                />
              </CCol>
              <CCol sm="12">
                <CTextarea
                  class="font-weight-bold"
                  label="Pesan"
                  rows="3"
                  placeholder="Masukkan Pesan"
                  v-model="formEmail.text"
                />
              </CCol>

              <CCol sm="12 mb-5">
                <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
                <br />
                <div class="custom-file text-truncate">
                  <div class="custom-file text-truncate">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="customFileLangHTML"
                      placeholder="Plih File"
                      @change="fileUpload"
                    />
                    <label
                      class="custom-file-label"
                      for="customFileLangHTML"
                      data-browse="Unggah"
                    >{{ fileName }}</label>
                  </div>
                  <small class="text-danger">* File harus berupa PDF max 10MB</small>
                </div>
              </CCol>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>            
          </template>
          <template #footer class="mt-5">
            <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
            <CButton @click="postDataEmail" type="submit" color="success">Kirim</CButton>
          </template>
        </CModal>
        <!-- End Modal -->

        <!-- Modal Verif -->
        <CModal
          title="Modal title"
          :show.sync="modalVerif"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm>
            <CRow>
              <div class="modal-body">
                <form>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="nama" class="font-weight-bold">Foto Terbaru</label>
                      <div class="text-center d-block">
                        <img src="/img/ic_pdf.png" width="100px" alt="icon" srcset />
                        <br />
                        <a href target="_blank" class="text-success">Lihat FIle</a>
                      </div>
                    </div>
                  </div>
                  <CCol sm="12 mb-4 mt-3">
                    <label for class="font-weight-bold">Status</label>
                    <br />
                    <div class="d-flex align-items-center">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="aktif"
                          value="1"
                        />
                        <label class="custom-control-label" for="aktif">Terverifikasi</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="tidak_aktif"
                          value="0"
                        />
                        <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                      </div>
                    </div>
                  </CCol>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="nama" class="font-weight-bold">KTP</label>
                      <div class="justify-content-center text-center">
                        <img src="/img/ic_pdf.png" width="100px" alt="icon" srcset />
                        <br />
                        <a href target="_blank" class="text-success">Lihat FIle</a>
                      </div>
                    </div>
                  </div>
                  <CCol sm="12 mb-4 mt-3">
                    <label for class="font-weight-bold">Status</label>
                    <br />
                    <div class="d-flex align-items-center">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="aktif"
                          value="1"
                        />
                        <label class="custom-control-label" for="aktif">Terverifikasi</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="tidak_aktif"
                          value="0"
                        />
                        <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                      </div>
                    </div>
                  </CCol>
                </form>
              </div>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h4 font-weight-bold">Verifikasi</h6>            
          </template>
          <template #footer>
            <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
            <CButton type="submit" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
      </CCardBody>
      <!-- End Data sesi 1 -->
    </CCard>
  </div>
</template>
<script>
import MasterJadwalTcService from "../../../services/sertifikasi/jadwal-tc-peserta.service.js";
import DataPesertaService from "../../../services/sertifikasi/data-peserta.service";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "no_anggota",
    label: "No.Anggota",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "nama_level",
    label: "Level",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "no_handphone",
    label: "No. Telepon",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "kehadiran",
    label: "Kehadiran",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "nama_sertifikasi",
    label: "Sertifikasi",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "mata_uji",
    label: "Mata Uji",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "tombol_dokumen_terverifikasi",
    label: "Persyaratan Dokumen",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "aksi",
    _style: "width:10%; vertical-align: middle;",
    sorter: false,
    filter: false
  }
];

export default {
  name: "JTC_Sesi1",
  data() {
    return {
      items: [],
      TestCenter: [],
      actionPost: "",
      namaTc: [],
      formEmail: {
        to: "",
        subject: "",
        text: "",
        attacment: ""
      },
      formdataKehadiran: {
        idJadwalTc: "",
        idSertifikasiPeserta: "",
        kehadiran: "",
        waktuPelaksanaan: "",
        nama_lengkap: "",
        nama_sertifikasi: "",
        mata_uji: ""
      },
      formData: {
        data_dokumen: {
          namaDokumen: "",
          statusUpload: "",
          file: "",
          idDokumenPendukungSertifikasi: ""
        },
        id_jadwal_tc: "",
        nama_sertifikasi: "",
        tombol_dokumen_terverifikasi: "",
        mata_uji: "",
        no_anggota: "",
        kehadiran: "",
        nama_lengkap: "",
        nama_level: "",
        waktu_pelaksanaan: "",
        email: "",
        no_handphone: "",
        id_sertifikasi_peserta: ""
      },
      pagination: {
        totalPages: 0
      },
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      modalVerif: false,
      modalEmail: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      fileName: "Choose File...",
      content: [],
      loading: true
    };
  },
  mounted() {
    this.getData(this.$route.params.id_jadwal_tc);

    $(".multi-select").each(function() {
      $(this).multipleSelect({
        placeholder: $(this).attr("placeholder")
      });
    });
  },
  methods: {
    sisa(event, k) {
      var data = event.target.value.split(".");
      document.getElementById("sisa" + k).value = data[1];
      // comment console console.log(k);
    },
    updateSelect(event) {
      var vm = this;
      this.formData.namaTc = event.namaTc;
    },
    pageChange() {
      this.getData(currentPage);
    },
    sendEmail(item) {
      this.modalEmail = true;
      this.formEmail.to = item.email;
      this.formEmail.subject = "";
      this.formEmail.text = "";
      this.formEmail.attacment = "";
      this.fileName = "";
    },
    postDataEmail() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(this.formEmail.to);
      DataPesertaService.postSendMessage(this.formEmail)
        .then(response => {
          // comment console console.log(response);
          this.alertSuccessSend();
          loader.hide();
          this.modalEmail = false;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertErrorSend();
        });
    },
    fileUpload(e) {
      this.formEmail.attacment = e.target.files[0];
      this.fileName = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertErrorSend() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Email Gagal Dikirim",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    alertSuccessSend() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Email Telah Terkirim"
      });
    },
    deleteData(item, index) {
      var vm = this;
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let loader = this.$loading.show({
              container: false ? null : this.$refs.formContainer,
              canCancel: true,
              onCancel: this.onCancel
            });
            MasterJadwalTcService.deleteJadwalTc(this.formData)
              .then(response => {
                // comment console console.log(response);
                loader.hide();
                vm.alertSuccess();
                vm.getData("0");
              })
              .catch(error => {
                loader.hide();
                vm.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getData(idJadwalTc) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      MasterJadwalTcService.getJadwalTcPeserta(idJadwalTc, "Sesi 2")
        .then(response => {
          loader.hide();
          // comment console console.log(response.data.data.content);
          vm.items = response.data.data;

          vm.idJadwalTc = vm.$route.params.id_jadwal_tc;
          setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    getJadwalTcPeserta() {
      var vm = this;
      MasterJadwalTcService.getJadwalTcPeserta("0")
        .then(response => {
          vm.namaTc = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item) {
      this.myModal = true;
      this.formdataKehadiran.nama_lengkap = item.nama_lengkap;
      this.formdataKehadiran.nama_sertifikasi = item.nama_sertifikasi;
      this.formdataKehadiran.idJadwalTc = this.$route.params.id_jadwal_tc;
      this.formdataKehadiran.waktuPelaksanaan = "Sesi 2";
      this.formdataKehadiran.mata_uji = item.mata_uji;
      this.formdataKehadiran.idSertifikasiPeserta = item.id_sertifikasi_peserta;
      // this.actionPost = "update";
      this.title = "Edit";
    },

    postData() {
      var vm = this;
      MasterJadwalTcService.postKehadiran(this.formdataKehadiran)
        .then(response => {
          vm.myModal = false;
          vm.alertSuccess();
          vm.getData(this.$route.params.id_jadwal_tc);
          // comment console console.log(response);

          // vm.$router.push({ path: "/sertifikasi/master-sertifikasi" });
        })
        .catch(error => {
          // comment console console.log(error);
          // vm.alertError(error.response.data.message);
          // vm.alertError();
        });
    },

    // postData() {
    //   if (this.actionPost == "insert") {
    //     this.insertData(this.formData);
    //   } else if (this.actionPost == "update") {
    //     this.putData();
    //   }
    // },

    insertData(formdataKehadiran) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.formData.tanggalPelaksanaan =
        this.formData.tanggalPelaksanaan + " 12:00:00";
      // comment console console.log(formData);
      // comment console console.log("post");
      var vm = this;
      MasterJadwalTcService.postJadwalTc(formData)
        .then(response => {
          vm.myModal = false;
          loader.hide();
          vm.alertSuccess();
          vm.getData("0");
        })
        .catch(error => {
          // comment console console.log(error);
          vm.alertError();
        });
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.formData.tanggalPelaksanaan =
        this.formData.tanggalPelaksanaan + " 12:00:00";
      // comment console console.log("put");
      // comment console console.log(this.formData);
      var vm = this;
      MasterJadwalTcService.putJadwalTc(this.formData)
        .then(response => {
          vm.myModal = false;
          loader.hide();
          vm.alertSuccess();

          vm.getData(this.$route.params.id_jadwal_tc);
        })
        .catch(error => {
          // comment console console.log(error);

          vm.alertError();
        });
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>